<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>

            <b-breadcrumb-item active>自動化模組</b-breadcrumb-item>
            <b-breadcrumb-item active>會員事件設定</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row d-flex mb-4 mb-xl-2 justify-content-between">
        <h4 class="col-4 col-xl-3 mb-2 font-weight-bold">會員事件設定</h4>
        <div class="
          col-12 col-xl-9 mb-2
          d-flex
          flex-xl-row
          align-items-center
          "
        >
          <b-button
            v-if="checkPermission([consts.MEMBER_EVENT_CREATE])"
            class="flex-shrink-0 mr-3"
            variant="primary"
            v-b-modal.modal-show
            >
            <i class="fa fa-plus"></i>新增事件
          </b-button>
          <b-form-select class="form-select mr-3" v-model="query.memberType" :options="typeOptions" @change="handlePageResetWithoutReload">

          </b-form-select>
          <b-form-select class="form-select mr-3" v-model="query.is_enabled" :options="enableOption" @change="handlePageResetWithoutReload">

          </b-form-select>
          <b-form-select class="form-select mr-3" v-model="query.process" :options="processingOption" @change="handlePageResetWithoutReload">

          </b-form-select>
          <b-input-group>
            <b-form-input v-model="query.keyword" placeholder="輸入活動名稱"
              @keyup.enter="handlePageResetWithoutReload"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                @click="handlePageResetWithoutReload"
              ><i class="fa fa-search"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <b-card-text>
        <div class="row">
          <div class="col-12">
            <b-overlay :show="showLoading" rounded="sm">
              <b-table
                striped
                hover
                responsive
                :items="items"
                :fields="fields"
              >
              <template #cell(status)="data">
                <b-badge :variant="data.item.is_enabled ? 'success' : 'danger'">
                  {{ data.item.is_enabled ? '啟用' : '未啟用' }}
                </b-badge>
              </template>
              <template #cell(actions)="data">
                <b-button
                  v-if="checkPermission([consts.MEMBER_EVENT_LIST_VIEW])"
                  class="mr-1"
                  variant="inverse-primary"
                  :to="{
                    name: 'AutoMarketingView',
                    params: {
                      config_id: data.item.id
                    }
                  }"
                >
                  <span class="mdi mdi-eye"></span> 查看
                </b-button>
                <b-button
                  v-if="checkPermission([consts.MEMBER_EVENT_MODIFY])"
                  class="mr-1"
                  variant="inverse-warning"
                  :to="{
                    name: 'AutoMarketingEdit',
                    params: {
                      config_id: data.item.id
                    }
                  }"
                >
                  <span class="mdi mdi-lead-pencil"></span> 編輯
                </b-button>
                <b-button
                  v-if="checkPermission([consts.MEMBER_EVENT_DELETE])"
                  variant="inverse-danger"
                  @click="handleDelete(data.item)">
                  <span class="mdi mdi-delete"></span> 刪除
                </b-button>
              </template>
              </b-table>
            </b-overlay>
          </div>
        </div>
        <div class="d-flex justify-content-center">
          <CustomPagination
            :currentPage="query.page"
            :totalRows="totalRows"
            :perPage="query.per_page"
            @page-change="handlePageChange"
            @per-page-change="handlePerPageChange"
          />
        </div>
      </b-card-text>
    </b-card>

    <b-modal id="modal-show" ok-title="關閉" centered ok-only>
      <b-card title="好友事件" class="mb-2">
        <b-button
          class="flex-shrink-0 mb-2 mb-xl-0"
          variant="primary"
          :to="{
            name: 'AutoMarketingMemberEventForm',
            params: {
              type: 'line_follow'
            }
          }"
          >新增</b-button
        >
      </b-card>

      <b-card title="註冊事件" class="mb-2">
        <b-button
          class="flex-shrink-0 mb-2 mb-xl-0"
          variant="primary"
          :to="{
            name: 'AutoMarketingMemberEventForm',
            params: {
              type: 'registered'
            }
          }"
          >新增</b-button
        >
      </b-card>

      <b-card title="生日事件" class="mb-2">
        <b-button
          class="flex-shrink-0 mb-2 mb-xl-0"
          variant="primary"
          :to="{
            name: 'AutoMarketingMemberEventForm',
            params: {
              type: 'birthday'
            }
          }"
          >新增</b-button
        >
      </b-card>

      <b-card title="封鎖事件">
        <b-button
          class="flex-shrink-0 mb-2 mb-xl-0"
          variant="primary"
          :to="{
            name: 'AutoMarketingMemberEventForm',
            params: {
              type: 'line_unfollow'
            }
          }"
          >新增</b-button
        >
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import * as consts from '@/consts'
import PermissionChecker from '@/utils/PermissionChecker'
import autoMarketingApi from "@/apis/auto-marketing";
import CustomPagination from "@/components/Page/Dashboard/CustomPagination.vue";
import { paginationMixin } from "@/mixins/pagination";
import { updateQueryFromRoute, updateUrlWithoutReload } from "@/utils/updateUrl";
import { mapGetters } from "vuex";

export default {
  name: "AutoMarketingMemberEvent",
  components: { CustomPagination },
  mixins: [paginationMixin],
  computed: {
    ...mapGetters("route", ["routeQuery"]),
    memberTypeParams() {
      return this.query.memberType === null ? ["line_follow", "registered", "birthday", "line_unfollow"] : [this.query.memberType]
    },
    typeOptions() {
      return [
        {
          value: null,
          text: "全部類別",
        },
        {
          value: "line_follow",
          text: "新好友",
        },
        {
          value: "registered",
          text: "會員註冊",
        },
        {
          value: "birthday",
          text: "會員生日",
        },
        {
          value: "line_unfollow",
          text: "用戶封鎖",
        }
      ]
    },
    enableOption(){
      return [
        {
          value: null,
          text: "全部狀態",
        },
        {
          value: 1,
          text: "啟用",
        },
        {
          value: 0,
          text: "未啟用",
        }
      ]
    },
    processingOption(){
      return [
        {
          value: 'all',
          text: "全部區間",
        },
        {
          value: 'going',
          text: "生效中",
        },
        {
          value: 'expired',
          text: "已失效",
        }
      ]
    },
    queryWatcher() {
      return `${this.query.page}-${this.query.per_page}`;
    },
  },
  data() {
    return {
      consts: consts,
      showLoading: false,
      totalRows: 0,
      initialized: false,
      query: {
        page: 1,
        per_page: 10,
        memberType: null,
        is_enabled: null,
        process: 'all',
        keyword: ''
      },
      items: [],
      fields: [
        {
          key: "name",
          label: "名稱",
          formatter: (_, key, item) => {
            return `${item.title}`
          }
        },
        {
          key: "type",
          label: "類別",
          formatter: (_, key, item) => this.typeOptions.find((option) => option.value === item.type)?.text
        },
        {
          key: "status",
          label: "狀態",
        },
        {
          key: "period",
          label: "使用區間",
          formatter: (_, key, item) => {
            const startDate = moment(item.start_at).format("YYYY-MM-DD HH:mm");
            const endDate = item.end_at && moment(item.end_at).isValid()
              ? moment(item.end_at).format("YYYY-MM-DD HH:mm")
              : "無期限";
            return `${startDate} ~ ${endDate}`;
          }
        },
        {
        key: "actions",
        label: "管理",
      },
      ],
    }
  },
  watch: {
    queryWatcher: {
      handler() {
        if (!this.initialized) return;
        updateUrlWithoutReload(this.query, this.$store, this.$router);
      },
    },
    routeQuery() {
      if (!this.initialized) return;
      this.fetchData();
    },
  },
  created() {
    this.query = updateQueryFromRoute(this.$route, this.$store, this.query);
  },
  mounted() {
    this.fetchData();
    this.initialized = true;
  },
  methods: {
    checkPermission (permissions) {
      const checker = new PermissionChecker;
      return checker.check(permissions);
    },
    async fetchData() {
      this.showLoading = true
      try {
        const params = {
          ...this.query,
          type: this.memberTypeParams,
        };
        const res = await autoMarketingApi.getMarketingConfigList(params)
        this.items = res.data.data
        this.totalRows = res.data.meta.total;
      } catch (error) {
        console.error(error)
      } finally {
        this.showLoading = false
      }
    },

    async handleDelete(config) {
      await this.$swal
        .fire({
          title: "你確定要刪除嗎？",
          html: `
            <div class="d-block">
              <div class="my-3">
                <div>事件名稱：${config.title}</div>
              </div>
              <div>刪除後，相關資料將無法回復，<br/>請您確認！</div>
            </div>`,
          type: "warning",
          confirmButtonText: "確定刪除",
          cancelButtonText: "不刪除",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true,
        })
        .then(async (result) => {
          if (result.value) {
            let response = await autoMarketingApi.removeMarketingConfig(config);
            if (response.status === 200) {
              this.$swal.fire({
                title: "成功",
                type: "success",
                text: "成功刪除 " + config.title,
              });
              this.fetchData();
            } else {
              if (response.data.message) {
                this.$swal.fire({
                  title: '錯誤',
                  type: "error",
                  text: response.data.message,
                });
              }
            }
          }
        });
    },
  },
}
</script>

<style lang="scss" scoped>
.form-select {
  width: 120px;
}
</style>
